import React, { FC, useState } from "react";
import { shallow } from "zustand/shallow";
import { EBtnType } from "@/models/common/enums";
import Image from "next/image";
import ModalConfirmLogout from "@/components/auth/logout/ModalConfirmLogout";
import {
    subTitleUploadAvatar,
    titleUploadAvatar,
} from "@/utils/mockData/bookingMocks";
import contactsSvg from "@/utils/svg-icon/contacts";
import styles from "../../../styles/common/Profile.module.scss";
import SectionNavigation from "./SectionNavigation";
import { useStore } from "../../../store";
import { ISectionButtonProps } from "../../../models/account";
import Btn from "../Btn";
import CustomModal from "../CustomModal";
import UploadAvatarModalBody from "./UploadAvatarModalBody";

const Profile: FC<ISectionButtonProps> = ({ buttons }) => {
    const { name, surname, email, avatar } = useStore(
        state => ({
            name: state.userState.userDetail.name,
            surname: state.userState.userDetail.surname,
            email: state.userState.userDetail.email,
            avatar: state.userState.userDetail.avatar,
        }),
        shallow
    );
    const [showModalLogout, setShowModalLogout] = useState(false);
    const [showModalUpload, setShowModalUpload] = useState(false);
    const { User } = contactsSvg;

    return (
        <>
            <div className={styles.container}>
                <div className={styles.topCard}>
                    <div className={styles.innerContainer}>
                        <div
                            className="pointer mb-3 me-2 me-md-0"
                            onClick={() => setShowModalUpload(true)}
                        >
                            {avatar ? (
                                <Image
                                    src={avatar}
                                    alt="profile"
                                    className={styles.image}
                                    width={100}
                                    height={100}
                                />
                            ) : (
                                <div className={styles.avatar}>
                                    <User />
                                </div>
                            )}
                        </div>

                        <div className={styles.content}>
                            <p className={styles.name}>
                                {name} {surname}
                            </p>
                            <p className={styles.email}>{email}</p>
                        </div>
                    </div>

                    <Btn
                        btnType={EBtnType.BLACK}
                        onClick={() => setShowModalLogout(true)}
                    >
                        Logout
                    </Btn>
                </div>

                <SectionNavigation buttons={buttons} />
            </div>
            <ModalConfirmLogout
                show={showModalLogout}
                setShow={() => setShowModalLogout(false)}
            />
            {showModalUpload && (
                <CustomModal
                    displayModal={showModalUpload}
                    setDisplayModal={() => setShowModalUpload(false)}
                    sectionTitle={{
                        title: titleUploadAvatar,
                        subTitle: subTitleUploadAvatar,
                    }}
                >
                    <UploadAvatarModalBody
                        onSuccessAfterUpload={() => setShowModalUpload(false)}
                    />
                </CustomModal>
            )}
        </>
    );
};

export default Profile;
